export default __webpack_public_path__ + "static/media/favorites-sweat.c7e41c82.png";